// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DN99Chc3KZ7BO7romLgU {
  margin-bottom: 44px;
}
@media only screen and (max-width: 1023px) {
  .DN99Chc3KZ7BO7romLgU {
    margin-bottom: 32px;
  }
}
@media only screen and (max-width: 767px) {
  .DN99Chc3KZ7BO7romLgU {
    flex-wrap: wrap;
    margin-bottom: 24px;
  }
}
.DN99Chc3KZ7BO7romLgU .EfEf6K0_w_gFTgxUZ3YR {
  margin-right: auto;
}
@media only screen and (max-width: 1023px) {
  .DN99Chc3KZ7BO7romLgU .EfEf6K0_w_gFTgxUZ3YR {
    width: 250px;
  }
}
@media only screen and (max-width: 767px) {
  .DN99Chc3KZ7BO7romLgU .EfEf6K0_w_gFTgxUZ3YR {
    width: 100%;
    margin: 0 0 16px;
  }
}
@media only screen and (max-width: 1023px) {
  .DN99Chc3KZ7BO7romLgU.WtbrfrZgLiulLT1Sfyp1 {
    display: none;
  }
}

.De8Mpo0u4beFsgDocLrX {
  margin-right: 24px;
}
@media only screen and (max-width: 767px) {
  .De8Mpo0u4beFsgDocLrX {
    margin: 0 0 16px;
  }
}

.y0v0q5rd6yr94p04QqYj {
  display: flex;
}
@media only screen and (max-width: 767px) {
  .y0v0q5rd6yr94p04QqYj {
    width: 100%;
  }
}

.Msfqb5eUgcsmAyCJkWFf {
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #6F767E;
  transition: all 0.2s;
}
@media only screen and (max-width: 767px) {
  .Msfqb5eUgcsmAyCJkWFf {
    flex: 1;
  }
}
.Msfqb5eUgcsmAyCJkWFf:hover, .Msfqb5eUgcsmAyCJkWFf.SJztt50cvqpSjHaWV826 {
  color: #1A1D1F;
}
.dark-mode .Msfqb5eUgcsmAyCJkWFf:hover, .dark-mode .Msfqb5eUgcsmAyCJkWFf.SJztt50cvqpSjHaWV826 {
  color: #FCFCFC;
}

.Msfqb5eUgcsmAyCJkWFf.SJztt50cvqpSjHaWV826 {
  background: #EFEFEF;
}
.dark-mode .Msfqb5eUgcsmAyCJkWFf.SJztt50cvqpSjHaWV826 {
  background: #272B30;
}

.Msfqb5eUgcsmAyCJkWFf:not(:last-child) {
  margin-right: 8px;
}
@media only screen and (max-width: 767px) {
  .Msfqb5eUgcsmAyCJkWFf:not(:last-child) {
    margin-right: 0;
  }
}

.hPsK3Ko5gRySoyftSq53 {
  margin-left: 8px;
}
@media only screen and (max-width: 1023px) {
  .hPsK3Ko5gRySoyftSq53 {
    display: none;
  }
}

.AGkPfto3XOziDX3CWMXF {
  display: none;
}

.Oxm_lVnVtTt1rTRWK3Bg.u_UT98JFQdAouq9JgrFS {
  display: flex;
}
.Oxm_lVnVtTt1rTRWK3Bg.u_UT98JFQdAouq9JgrFS .IhDSBiAkEf4l2QRmrYeC {
  flex-shrink: 0;
  width: 384px;
}
@media only screen and (max-width: 1419px) {
  .Oxm_lVnVtTt1rTRWK3Bg.u_UT98JFQdAouq9JgrFS .IhDSBiAkEf4l2QRmrYeC {
    width: 350px;
  }
}
@media only screen and (max-width: 1259px) {
  .Oxm_lVnVtTt1rTRWK3Bg.u_UT98JFQdAouq9JgrFS .IhDSBiAkEf4l2QRmrYeC {
    width: 320px;
  }
}
@media only screen and (max-width: 1023px) {
  .Oxm_lVnVtTt1rTRWK3Bg.u_UT98JFQdAouq9JgrFS .IhDSBiAkEf4l2QRmrYeC {
    display: none;
  }
}
.Oxm_lVnVtTt1rTRWK3Bg.u_UT98JFQdAouq9JgrFS .AGkPfto3XOziDX3CWMXF {
  display: block;
}

.PfzzaqhhZSodRQ4o4NIs {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
@media only screen and (max-width: 767px) {
  .PfzzaqhhZSodRQ4o4NIs {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.fcFMRoSjb7yQGX6yEa6o {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  color: #6F767E;
  margin-right: 12px;
}
@media only screen and (max-width: 767px) {
  .fcFMRoSjb7yQGX6yEa6o {
    margin-right: 0;
  }
}

.M9gIupmCykYUevh7CxVa {
  padding: 8px 12px;
  border: 1px solid #EFEFEF;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  color: #1A1D1F;
  background: #FCFCFC;
  cursor: pointer;
  transition: all 0.2s;
}
.dark-mode .M9gIupmCykYUevh7CxVa {
  border-color: #272B30;
  color: #FCFCFC;
  background: #111315;
}

.M9gIupmCykYUevh7CxVa:hover {
  border-color: #6F767E;
}
.dark-mode .M9gIupmCykYUevh7CxVa:hover {
  border-color: #33383F;
}

.M9gIupmCykYUevh7CxVa:focus {
  outline: none;
  border-color: #2A85FF;
}
.dark-mode .M9gIupmCykYUevh7CxVa:focus {
  border-color: #2A85FF;
}

.JmmFFFpEyECBnxRMiu_M {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #F4F4F4;
  border-radius: 8px;
  margin-bottom: 16px;
}
.dark-mode .JmmFFFpEyECBnxRMiu_M {
  background: #1A1D1F;
}

@media only screen and (max-width: 767px) {
  .JmmFFFpEyECBnxRMiu_M {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
}

.tT3ZEFDd_OGnt5QWxWA8 {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  color: #272B30;
}
.dark-mode .tT3ZEFDd_OGnt5QWxWA8 {
  color: #EFEFEF;
}

.jChNQkup4BQYRAQfkK3U {
  padding: 4px 8px;
  border: none;
  background: none;
  color: #2A85FF;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  border-radius: 4px;
  transition: all 0.2s;
}
.jChNQkup4BQYRAQfkK3U:hover {
  background: #2A85FF;
  color: #FCFCFC;
}

.TP0FYM4KwjE1xBiSscqe {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #2A85FF;
  color: #FCFCFC;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  transition: all 0.2s;
}
.TP0FYM4KwjE1xBiSscqe:hover {
  background: #0069f6;
}

.th_9wDriLF6m3853UDEz {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/users/CustomerList.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,mBAAA;AADJ;ACWI;EDXJ;IAGQ,mBAAA;EACN;AACF;ACSI;EDdJ;IAKQ,eAAA;IACA,mBAAA;EAIN;AACF;AAJI;EACI,kBAAA;AAMR;ACHI;EDJA;IAGQ,YAAA;EAQV;AACF;ACLI;EDPA;IAKQ,WAAA;IACA,gBAAA;EAWV;AACF;ACdI;EDGA;IAEQ,aAAA;EAaV;AACF;;AAZA;EACI,kBAAA;AAeJ;ACpBI;EDIJ;IAGQ,gBAAA;EAiBN;AACF;;AAhBA;EACI,aAAA;AAmBJ;AC7BI;EDSJ;IAGQ,WAAA;EAqBN;AACF;;AApBA;EACI,iBAAA;EACA,kBAAA;EC8CA,eAAA;EACA,gBAAA;EACA,gBAAA;ED9CA,cCUC;EDTD,oBAAA;AAyBJ;AC5CI;EDcJ;IAOQ,OAAA;EA2BN;AACF;AA3BI;EAEI,cCOH;ADqBL;ACwHa;EDlJD,cCDP;AD8BL;;AA5BI;EACI,mBCDH;ADgCL;ACiHa;ED9ID,mBAAA;AAgCZ;;AA/BI;EACI,iBAAA;AAkCR;AClEI;ED+BA;IAGQ,eAAA;EAoCV;AACF;;AAnCA;EACI,gBAAA;AAsCJ;AC9EI;EDuCJ;IAGQ,aAAA;EAwCN;AACF;;AAvCA;EACI,aAAA;AA0CJ;;AAvCI;EACI,aAAA;AA0CR;AAzCQ;EACI,cAAA;EACA,YAAA;AA2CZ;ACxGI;ED2DI;IAIQ,YAAA;EA6Cd;AACF;ACvGI;EDqDI;IAMQ,YAAA;EAgDd;AACF;ACzGI;EDkDI;IAQQ,aAAA;EAmDd;AACF;AAnDQ;EACI,cAAA;AAqDZ;;AAnDA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAsDJ;ACpHI;ED2DJ;IAKQ,sBAAA;IACA,uBAAA;IACA,QAAA;EAwDN;AACF;;AAvDA;ECII,eAAA;EACA,gBAAA;EACA,yBAAA;EDJA,cC1CC;ED2CD,kBAAA;AA4DJ;ACnII;EDoEJ;IAKQ,eAAA;EA8DN;AACF;;AA7DA;EACI,iBAAA;EACA,yBAAA;EACA,kBAAA;ECNA,eAAA;EACA,gBAAA;EACA,yBAAA;EDMA,cCjDC;EDkDD,mBCxDC;EDyDD,eAAA;EACA,oBAAA;AAkEJ;ACuBa;EDvFL,qBCvDH;EDwDG,cC7DH;ED8DG,mBCvDH;AD0HL;;AAlEI;EACI,qBC7DH;ADkIL;ACca;EDjFD,qBC9DP;ADoIL;;AArEI;EACI,aAAA;EACA,qBChFH;ADwJL;ACMa;ED5ED,qBClFP;AD2JL;;AAvEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBC7EC;ED8ED,kBAAA;EACA,mBAAA;AA0EJ;ACPa;EDjEL,mBC5EH;ADuJL;;ACtLI;EDkGJ;IAWQ,sBAAA;IACA,SAAA;IACA,oBAAA;EA8EN;AACF;;AA7EA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EC5CA,eAAA;EACA,gBAAA;EACA,yBAAA;ED4CA,cCxFC;AD0KL;AC5Ba;EDpDL,cC7FH;ADgLL;;AAjFA;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,cChHC;EDiHD,eAAA;ECvDA,eAAA;EACA,gBAAA;EACA,yBAAA;EDuDA,kBAAA;EACA,oBAAA;AAsFJ;AArFI;EACI,mBCtHH;EDuHG,cC5GH;ADmML;;AArFA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBC7HC;ED8HD,cCnHC;EDoHD,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;ECxEA,eAAA;EACA,gBAAA;EACA,yBAAA;EDwEA,oBAAA;AA0FJ;AAzFI;EACI,mBAAA;AA2FR;;AAzFA;EACI,iBAAA;AA4FJ","sourcesContent":["@import ../../styles/helpers\n\n.head\n    margin-bottom: 44px\n    +t\n        margin-bottom: 32px\n    +m\n        flex-wrap: wrap\n        margin-bottom: 24px\n    .form\n        margin-right: auto\n        +t\n            width: 250px\n        +m\n            width: 100%\n            margin: 0 0 16px\n    &.hidden\n        +t\n            display: none\n\n.title\n    margin-right: 24px\n    +m\n        margin: 0 0 16px\n\n.nav\n    display: flex\n    +m\n        width: 100%\n\n.link\n    padding: 8px 16px\n    border-radius: 8px\n    +base1-s\n    color: $n4\n    transition: all .2s\n    +m\n        flex: 1\n    &:hover,\n    &.active\n        color: $n7\n        +dark\n            color: $n1\n    &.active\n        background: $n3\n        +dark\n            background: $n6\n    &:not(:last-child)\n        margin-right: 8px\n        +m\n            margin-right: 0\n\n.filters\n    margin-left: 8px\n    +t\n        display: none\n\n.details\n    display: none\n\n.row\n    &.flex\n        display: flex\n        .table\n            flex-shrink: 0\n            width: 384px\n            +w\n                width: 350px\n            +d\n                width: 320px\n            +t\n                display: none\n        .details\n            display: block\n\n.paginationControls\n    display: flex\n    align-items: center\n    margin-bottom: 16px\n    +m\n        flex-direction: column\n        align-items: flex-start\n        gap: 8px\n\n.itemsPerPageLabel\n    +base2\n    color: $n4\n    margin-right: 12px\n    +m\n        margin-right: 0\n\n.itemsPerPageSelect\n    padding: 8px 12px\n    border: 1px solid $n3\n    border-radius: 8px\n    +base2\n    color: $n7\n    background: $n1\n    cursor: pointer\n    transition: all .2s\n    +dark\n        border-color: $n6\n        color: $n1\n        background: $n8\n    &:hover\n        border-color: $n4\n        +dark\n            border-color: $n5\n    &:focus\n        outline: none\n        border-color: $p1\n        +dark\n            border-color: $p1\n\n.bulkControls\n    display: flex\n    align-items: center\n    justify-content: space-between\n    padding: 12px 16px\n    background: $n2\n    border-radius: 8px\n    margin-bottom: 16px\n    +dark\n        background: $n7\n    +m\n        flex-direction: column\n        gap: 12px\n        align-items: stretch\n\n.bulkInfo\n    display: flex\n    align-items: center\n    gap: 12px\n    +base2\n    color: $n6\n    +dark\n        color: $n3\n\n.clearSelection\n    padding: 4px 8px\n    border: none\n    background: none\n    color: $p1\n    cursor: pointer\n    +base2\n    border-radius: 4px\n    transition: all .2s\n    &:hover\n        background: $p1\n        color: $n1\n\n.bulkActionButton\n    display: flex\n    align-items: center\n    gap: 8px\n    background: $p1\n    color: $n1\n    border: none\n    padding: 8px 16px\n    border-radius: 6px\n    cursor: pointer\n    +base2\n    transition: all .2s\n    &:hover\n        background: darken($p1, 10%)\n\n.exportButton\n    margin-right: 5px","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head": `DN99Chc3KZ7BO7romLgU`,
	"form": `EfEf6K0_w_gFTgxUZ3YR`,
	"hidden": `WtbrfrZgLiulLT1Sfyp1`,
	"title": `De8Mpo0u4beFsgDocLrX`,
	"nav": `y0v0q5rd6yr94p04QqYj`,
	"link": `Msfqb5eUgcsmAyCJkWFf`,
	"active": `SJztt50cvqpSjHaWV826`,
	"filters": `hPsK3Ko5gRySoyftSq53`,
	"details": `AGkPfto3XOziDX3CWMXF`,
	"row": `Oxm_lVnVtTt1rTRWK3Bg`,
	"flex": `u_UT98JFQdAouq9JgrFS`,
	"table": `IhDSBiAkEf4l2QRmrYeC`,
	"paginationControls": `PfzzaqhhZSodRQ4o4NIs`,
	"itemsPerPageLabel": `fcFMRoSjb7yQGX6yEa6o`,
	"itemsPerPageSelect": `M9gIupmCykYUevh7CxVa`,
	"bulkControls": `JmmFFFpEyECBnxRMiu_M`,
	"bulkInfo": `tT3ZEFDd_OGnt5QWxWA8`,
	"clearSelection": `jChNQkup4BQYRAQfkK3U`,
	"bulkActionButton": `TP0FYM4KwjE1xBiSscqe`,
	"exportButton": `th_9wDriLF6m3853UDEz`
};
export default ___CSS_LOADER_EXPORT___;
